export const C = {
    primary: "#0056b3",
    primaryDark: "#003d7f",
    primaryLight: "#e6f0ff",
    accent: "#ffc744",
    accentDark: "#fdb813",
    neutral: "#333333",
    neutralLight: "#f8f9fa",
    white: "#ffffff",
    gray: "#666666",
    grayLight: "#999999",
    border: "#e2e8f0",
};